<template>
  <div style="padding: 0 40px">
    <ul class="rolelist-row">
      <li @click="checkTab(0)" :class="{ check: roleTab == 0 }">我的角色</li>
      <li @click="checkTab(1)" :class="{ check: roleTab == 1 }">角色中心</li>
      <!-- <li @click="logUser()" :class="{ check: roleTab == 1 }">log</li> -->
      <li @click="newmodel()">导入角色</li>
      <div style="" class="search">
        <!-- <i class="iconfont icon-gantanhao"></i>请点击选择您要使用的虚拟形象！ -->
        <select
          v-model="isCommercial"
          v-if="roleTab == 1"
          @change="searchRole()"
          class="myselect"
          style=""
        >
          <option value="">是否商用</option>
          <option value="1">允许</option>
          <option value="0">不允许</option>
        </select>
        <input
          @keyup.enter="searchRole"
          v-model="searchText"
          type="text"
          placeholder="输入关键词搜索"
          :style="{ width: roleTab == 1 ? '180px' : '270px' }"
        />
        <i @click="searchRole()" class="iconfont icon-sousuoxiao"></i>
      </div>
    </ul>
    <div class="contentRole" style="">
      <TabMyRole
        ref="myRole"
        v-if="roleTab == 0"
        @ModelCheck="change"
        @openEditUser="openEditUser"
        @EditSuccess="EditSuccess"
        @checkRole="checkRole"
        :user="user"
        :t9render="t9render"
        :modelloading="modelloading"
        @toCenter="toCenter"
        @showAdds="showAdds"
        :isshow="isshow"
        :isH5="isH5"
      ></TabMyRole>
      <TabRoleCenter
        ref="tabRoleCenter"
        v-if="roleTab == 1"
        @ModelCheck="change"
        @checkRole="checkRole"
        :user="user"
        :t9render="t9render"
      ></TabRoleCenter>
      <!-- 渲染器容器位置 -->
      <div class="" id="myRole-Rongqi" ref="myRole_Rongqi"></div>
    </div>

    <!-- 编辑角色 -->
    <AddRole
      v-if="showEdit"
      ref="uploadCenter"
      :user="editUser"
      :t9render="t9render"
      @change="change"
      @closebox="closebox"
      @success="EditSuccess"
      @ModelCheck="ModelCheck"
      :copyT9v="t9video"
    ></AddRole>

    <Menu
      ref="Menu"
      v-if="showMenu && activeTab == 0"
      @close="closeMenu"
      :user="user"
      @updateUser="updateUser"
      :t9render="t9render"
    ></Menu>

    <!--加入我的角色（包含角色使用声明）-->
    <div class="addserbox" style="position: fixed" v-if="showAdd">
      <div class="add-title">
        角色使用声明<span @click="showAdd = false">+</span>
      </div>
      <div class="add-content">
        <div
          class="varbox"
          :style="{
            'margin-bottom': isShowComplywith && user.isHad ? '30px' : '',
          }"
        >
          <div @click="logUser(user)">
            本角色由用户 <span class="pink">{{ user.userName }}</span> 于{{
              user.createDate
            }}上传；
          </div>
          <div>
            {{
              user.sourceIntroduction
                ? "来源于：" + user.sourceIntroduction
                : ""
            }}
          </div>
          <div>使用规则如下：</div>
          <div>
            <i
              class="iconfont icon-zhengque"
              v-if="user.platform[0].isCommercial == 1"
            ></i
            ><i class="iconfont icon-cuowu" v-else></i
            ><span
              >{{
                user.platform[0].isCommercial == 1 ? "" : "不"
              }}允许商用</span
            >
            <!-- ><span>{{ user.isCommercial == 1 ? "" : "不" }}允许商用</span> -->
          </div>
          <!-- <div>
            <i class="iconfont icon-zhengque" v-if="user.isCreation == 1"></i
            ><i class="iconfont icon-cuowu" v-else></i
            ><span>{{ user.isCreation == 1 ? "" : "不" }}允许二次创作</span>
          </div> -->
          <div>
            <i class="iconfont icon-zhengque" v-if="user.isModify == 1"></i
            ><i class="iconfont icon-cuowu" v-else></i
            ><span>{{ user.isModify == 1 ? "" : "不" }}允许修改模型</span>
          </div>
          <!-- <div>
            <i class="iconfont icon-zhengque" v-if="user.isLive == 1"></i
            ><i class="iconfont icon-cuowu" v-else></i
            ><span>{{ user.isLive == 1 ? "" : "不" }}允许用于直播</span>
          </div> -->
          <div v-if="user" v-show="user.type == 2">
            同意并遵守《<a
              href="https://www.live2d.jp/terms/live2d-free-material-license-agreement/"
              target="_blank"
              >Live2D免费使用条款</a
            >》
          </div>
        </div>
        <div class="btn-group" v-show="!user.isHad">
          <div class="cannel" @click="showAdd = false">不用了</div>
          <div class="sure" @click="addModelToMe">
            {{ addloading ? "添加中..." : "愿意遵守" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { localData, asyncLoadJs, validate } from '@/components/util/util_fun.js'
import { T9Video } from '@/components/video/t9video.js'

export default {
  name: 'Background',
  props: ['user', 't9render', 'modelloading', 'isH5', 'isshow', 'activeTab', 'isCollapse'],
  components: {
    TabMyRole: () => import(/*webpackChunkName:"Role"*/'../role/MyRole.vue'),
    TabRoleCenter: () => import(/*webpackChunkName:"Role"*/'../role/RoleCenter.vue'),
    AddRole: () => import(/*webpackChunkName:"Role"*/'../role/AddRole.vue'),
    Menu: () => import(/*webpackChunkName:"Role"*/'../role/menu/Menu.vue'),

  },
  data () {
    return {
      roleTab: 0,
      showMenu: false,
      showEdit: false,
      isShowComplywith: false,
      showAdd: false,
      addloading: false,
      editUser: null,
      searchText: '',
      isCommercial: '',// 是否商用 0:false 1:true
      t9video: null
    }
  },
  created () {
    // console.log('this.modelClass角色', this.modelClass)
    window.t9render.setRoleScene = this.setSceneSelf
  },
  mounted () {
    // 打开渲染器
    window.t9render.modelopen("id", "iframe", "myRole-Rongqi")
    // console.dir(this.$refs.myRole_Rongqi)
    this.t9video = new T9Video()
    this.t9video.videoobj.scenes[0].width = 390
    this.t9video.videoobj.scenes[0].height = 680
    let role = localData("get", "historyHodel_" + this.$store.state.userinfo.userId)
    // 判断role对象是否包含key属性
    if ('key' in role) {
      // console.log('当前role有key', role)
    } else {
      const data = this.getKey(role.rolesId)
      // console.log('当前role没有key', role, data)
      this.post("/secret/getEncryptionInfo", { typeId: role.rolesId, type: 1 }).then(data => {
        if (data.status == "200") {
          if (data.data) { //获取密钥后调用父组件的编辑方法切换角色
            role.key = data.data
          }
        }
        else {
          return this.$message.error("获得秘钥失败")
        }
      })
    }
    // console.log('获取的本地保存的角色role', role)
    this.t9video.videoobj.scenes[0].res.push({
      resid: role.rolesId,
      resname: role.rolesName,
      // resimg: role.rolesPhoto,//资源封面
      resobj: role,
      restype: 1,
      startend: [0, 0],
      timeline: []
    })


  },
  methods: {
    async getKey (user) {
      const data = await this.post("/secret/getEncryptionInfo", { typeId: user.rolesId, type: 1 })
      if (data.status == "200") {
        if (data.data) { //获取密钥后调用父组件的编辑方法切换角色
          user.key = data.data
          console.log('点击编辑调用父组件的编辑方法', user)

        }
      }
      else {
        return this.$message.error("获得秘钥失败")
      }
      return user
    },
    setSceneSelf (data) { // t9render.js中监听到渲染器加载完成的的事件,执行方法
      // console.log('vue组件中的方法', data)
      t9render.setScene(this.t9video.videoobj.scenes[0])
    },
    logUser () {
      console.log('logUser', this.user)
    },
    searchRole () {
      if (this.roleTab == 1) {
        // console.log('搜索角色中心', this.searchText)
        this.$refs.tabRoleCenter.getUserModelList(this.searchText, this.isCommercial)
      }
      if (this.roleTab == 0) {
        this.isCommercial = ''
        this.$refs.myRole.getUserModelList(this.searchText, true)
      }
    },

    /**
     * 导入角色
     */
    newmodel () {
      this.editUser = null
      this.showEdit = true
    },
    closebox () {
      this.showEdit = false
    },
    closebtn () {

      this.$emit('closebtn')
    },
    closeMenu () {
      this.showMenu = false
    },
    // *******************************************************************
    //添加到我的角色
    addModelToMe () {
      if (this.addloading) {
        return
      }
      this.addloading = true
      var that = this
      this.post("/platform/saveRoles",
        { rid: that.user.rolesId, uid: this.$store.state.userinfo.userId }).then((res) => {
          that.addloading = false
          that.showAdd = false
          if (res.status == "200") {
            // PixiCommon.clearBack()
            that.user.isHad = true
            res.data.isHad = true
            // this.$refs.myRole.updateUser()//不传参数，会刷新整个页面
            this.checkTab(0)
            // this.change(that.user)
            that.$message.success("添加成功")
          } else {
            that.$message.error("添加失败，" + res.message + ",请选择其它角色！")
          }
        })
        .catch(() => {
          that.$message.error("添加异常")
          that.addloading = false
        })
    },

    //主舞台模型加载完毕，继续新增
    modelLoadSuccess (status) {

      //这里证明是上传中断的，恢复一下
      if (this.$refs.uploadCenter == undefined) {
        this.roleTab = 2
      }
      var that = this
      setTimeout(function () {
        that.$refs.uploadCenter.modelLoadSuccess(status)
      }, 100)

    },

    //新增成功后的回调
    addSuccess (user) {
      // console.log(user);
      // console.log(this.user);
      this.roleTab = 0
      this.ModelCheck(user)

    },
    change (user) {
      // console.log('换人且更新角色', user)
      this.$emit("change", user)//换人且更新角色
    },
    // *******************************************************************
    //角色切换事件
    ModelCheck (user) {
      if (user) {
        console.log('只换人，不切换当前页面', user)
        this.$emit("change", user, false)//只换人，不切换当前页面
      }
    },
    checkMenu () {

      this.showMenu = !this.showMenu
    },
    showAdds () {
      console.log('showAdds', this.user)
      this.showAdd = true
    },
    updateUser (user) {
      if (user) {
        //  this.user = user;
        localData("set", "historyHodel_" + this.$store.state.userinfo.userId, user)
        // console.log("ccccc",user);
        // debugger

      }
      this.$refs.myRole.updateUser(user)//不传参数，会刷新整个页面
    },
    toCenter () {
      this.roleTab = 1
    },

    openEditUser (user) {
      // console.log('openEditUser', user.rolesId, this.user.rolesId)
      console.log('myrole组件调用他brow的openEditUser方法打印id', user.rolesId, this.user.rolesId)
      // if (user.rolesId != this.user.rolesId)
      this.$emit('update:user', user)
      if (user.rolesId != this.user.rolesId) {
        this.checkRole(user)
        this.editUser = user
        this.showEdit = true
      } else {
        this.editUser = user
        this.showEdit = true
      }

    },
    async checkRole (user) {

      if (!user.key) {
        console.log('没有key')
        try {
          const data = await this.post("/secret/getEncryptionInfo", { typeId: user.rolesId, type: 1 })
          if (data.status == "200") {
            if (data.data) {
              user.key = data.data
              let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
              var tl = this.t9video.videoobj.scenes[0].res[roleIndex]
              if (tl) {
                //无论时间线中的人物是谁，都改成当前角色
                tl.resid = user.rolesId
                tl.resimg = user.rolesPhoto//资源封面
                tl.resname = user.rolesName//资源名称
                tl.resobj = user
              }
              localData("set", "historyHodel_" + this.$store.state.userinfo.userId, user)
              t9render.setScene(this.t9video.videoobj.scenes[0])
            }
          }
          else {
            this.$message.error("获得秘钥失败")
          }
        } catch (error) {
          this.$message.error("获得秘钥失败")
        }
      } else {
        let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
        var tl = this.t9video.videoobj.scenes[0].res[roleIndex]
        if (tl) {
          //无论时间线中的人物是谁，都改成当前角色
          tl.resid = user.rolesId
          tl.resimg = user.rolesPhoto//资源封面
          tl.resname = user.rolesName//资源名称
          tl.resobj = user
        }
        console.log('已经获得秘钥直接打开', this.t9video.videoobj.scenes[0])

        t9render.setScene(this.t9video.videoobj.scenes[0])
        localData("set", "historyHodel_" + this.$store.state.userinfo.userId, user)
      }

    },
    //编辑成功后
    EditSuccess (user) {
      this.$emit('update:user', user)
      // this.checkRole(user)
      localData("set", "historyHodel_" + this.$store.state.userinfo.userId, user)
      this.showEdit = false
      this.$refs.myRole.initParam()
    },
    checkTab (val) {
      this.searchText = '' // 清空搜索框
      this.isCommercial = '' // 初始化select选框
      this.roleTab = val

      // this.$emit('isShowComply', this.roleTab)
    }

  },

}
</script>

<style lang="scss" scoped>
@import "@/style/mixin.scss";
#myRole-Rongqi {
  // width: 390PX; /*no*/
  width: 30%; /*no*/
  height: 680PX; /*no*/
  // background-color: rgb(100, 100, 100);
  position: relative;
  margin: 0 auto;
}
.contentRole {
  display: flex;
  // padding: 0 40px;
}
.rolelist-row {
  width: 880px;
  // margin: 0 auto;
  width: 60%;
}
.search {
  box-sizing: border-box;
  width: 320px;
  height: 35px;
  border: 1px solid;
  border-radius: 30px; //把边框设计成半圆
  @include border_color("bordercolor");
  display: flex;
  margin-right: 5px;
  margin-left: auto;
  line-height: 31px;
  overflow: hidden;
  input {
    width: 270px;
    height: 35px;
    border: 0; //去掉input边框
    font-size: 14px;
    outline: none;
    font-size: 12px;
    margin: 0 10px;
    @include border_color("bordercolor");
    // @include background("uibg");
    background: transparent;
    @include font_color("fontcolor");
  }
  &:hover {
    box-shadow: 0px 0px 1px 1px;
  }

  i {
    margin-right: 10px;
    font-size: 18px;
    cursor: pointer;
  }
}
</style>